export const baseCodeTagStyle = {
  maxHeight: '500px',
  maxWidth: '100%',
  margin: '0',
  boxSizing: 'border-box',
  overflow: 'auto',
  display: 'block',
  padding: '1em'
};
export const baseInlineCodeStyle = {
  padding: '2px 5px',
  borderRadius: '4px',
  fontFamily: 'monospace',
  border: '1px solid rgba(214, 230, 254, 1)',
  fontSize: '12px',
  background: 'rgba(255, 255, 255, 0.2)'
};
export const defaultInlineCodeStyle = {
  color: '#24292e !important',
  textShadow: 'white 0px 1px',
  border: '1px solid rgba(207, 209, 220, 1)',
  background: 'rgba(236, 239, 243, 0.5)'
};
//# sourceMappingURL=styles.js.map